import CommercialSuppliersApi, {
  UpdateCommercialSupplierPayload,
} from '../useCommercialSuppliers/api'

const updateCommercialSupplier = async (id: number, payload: UpdateCommercialSupplierPayload) =>
  CommercialSuppliersApi.updateCommercialSupplier(id, payload)

export { updateCommercialSupplier }
export type { UpdateCommercialSupplierPayload }
